/* Monucube scroll-reveal — canlı sitedeki Webflow IX2 davranışının karşılığı. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var groups = document.querySelectorAll('.mc-reveal-group');
  groups.forEach(function (g) {
    var scale = g.dataset.reveal === 'scale';
    Array.prototype.forEach.call(g.children, function (child, i) {
      child.classList.add('mc-reveal');
      if (scale) child.classList.add('mc-reveal--scale');
      child.style.transitionDelay = (i * 0.09).toFixed(2) + 's';
    });
  });

  // Açılışta zaten ekranda olan öğeler gizlenmez: hero başlığı gibi LCP öğelerini
  // animasyon bitene kadar bekletmemek için yalnızca ekran altındakiler canlandırılır.
  var fold = window.innerHeight || document.documentElement.clientHeight;
  var els = Array.prototype.filter.call(document.querySelectorAll('.mc-reveal'), function (el) {
    if (el.getBoundingClientRect().top < fold) { el.style.transitionDelay = ''; return false; }
    return true;
  });
  els.forEach(function (el) { el.classList.add('mc-reveal--init'); });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mc-reveal--in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  els.forEach(function (el) { io.observe(el); });
})();
